<script setup lang="ts">
import {computed, ref} from "vue";
import {ICellRendererParams} from "ag-grid-community";
import ImagePreviewer from "@/components/dialogs/ImagePreviewer.vue";
import DTOFileAttachmentInfo = namaTypes.DTOFileAttachmentInfo;

const props = defineProps<{ params: ICellRendererParams }>();
const entityType: string = props.params["entityType"];
const imageVisible = ref(false)
let mouseIn = false;

const attachmentInfo = computed<DTOFileAttachmentInfo | undefined>(() => props.params.value?.attachmentInfo);

function isAttachmentExist(): boolean {
  const info = attachmentInfo.value;
  return !!(info && info.fileId && !info.removed);
}

function getFileName(): string {
  return attachmentInfo.value?.fileName ?? "";
}

const computedUrl = computed(() => {
  if (!isAttachmentExist())
    return "";
  return `file.download?fileID=${attachmentInfo.value!.fileId}&entitytype=${entityType}&ischanged=false`;
});

function onMouseEnter() {
  mouseIn = true;
  if (imageVisible.value)
    return;
  setTimeout(() => {
    if (!mouseIn)
      return;
    imageVisible.value = true;
  }, 1000);
}

function onMouseLeave() {
  mouseIn = false;
}
</script>

<template>
  <q-item class="tw-w-full tw-h-full tw-p-0 tw-flex tw-items-center" dense>
    <div class="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-between tw-gap-2">
      <ImagePreviewer v-if="isAttachmentExist()" v-model="imageVisible"
                      :src="computedUrl" :fileName="getFileName()"/>
      <a
        class="tw-overflow-hidden tw-inline-flex"
        v-if="isAttachmentExist()"
        :href="computedUrl"
        target="_blank">
        <q-chip
          class="nama-chip !tw-max-w-full !tw-w-full tw-m-0"
          clickable
          @mouseenter="onMouseEnter"
          @mouseleave="onMouseLeave"
          square
          :label="getFileName()"
          :title="getFileName()">
        </q-chip>
      </a>
    </div>
  </q-item>
</template>
